const film_root_el = document.getElementById('film_root')


//
// Subtitles
//
// `cc_load_policy: 0` is only a hint to the player, so also turn captions
// off through the api. `remove` unloads the captions module completely
// (no CC button at all) - used for the silent looping trailers. Otherwise
// the track is just cleared, so subtitles start off but the viewer can
// still switch them on from the player controls.
//
function disable_captions (player, remove) {
  if (!player) return
  try {
    if (remove) {
      player.unloadModule('captions')  // html5 player
      player.unloadModule('cc')        // legacy player
      return
    }
    const options = (player.getOptions && player.getOptions()) || []
    if (options.indexOf('captions') !== -1) {
      player.setOption('captions', 'track', {})
    }
    if (options.indexOf('cc') !== -1) {
      player.setOption('cc', 'track', {})
    }
  }
  catch (e) {
    // player not ready for module calls yet - onApiChange will retry
  }
}

// 
//  Film Page Contents:
//    1. Trailer
//    2. Film
//    3. Gallery
//    4. Thumbs
//    5. Main
//
//  Each section contains:
//    1. State
//    2. Event Handlers
//    3. Initial DOM
//    4. A "render" function
// 


//
// Trailer
//

let trailer_video = null


function update_url () {
  var url = new URL(window.location)
  var search_params = url.searchParams
  search_params.set('film', current_film_index+1)
  url.search = search_params.toString()
  var new_url = url.toString()
  window.history.pushState(null, null, new_url)
}


function handle_trailer_right_arrow_el_click () {
  previous_film_index = current_film_index
  current_film_index = current_film_index + 1

  if (previous_film_index == 0) {
    trailer_left_arrow_el.style.opacity = ''
    trailer_left_arrow_el.style.pointerEvents = ''
  }

  render_main()
  update_url()
}


function handle_trailer_left_arrow_el_click () {
  previous_film_index = current_film_index
  current_film_index = current_film_index - 1

  if (previous_film_index == page_data.films.length - 1) {
    trailer_right_arrow_el.style.opacity = ''
    trailer_right_arrow_el.style.pointerEvents = ''
  }

  render_main()
  update_url()
}

function handle_trailer_yt_ready (event) {
  trailer_video.mute()
  disable_captions(event.target, true)
  trailer_video.playVideo()
}

// The captions module only exists once the player reports an api change,
// so turn subtitles off again there. The trailer has no controls, so its
// captions module is unloaded outright.
function handle_trailer_yt_api_change (event) {
  disable_captions(event.target, true)
}

function handle_trailer_yt_state_change (e) {
  if (e.data === YT.PlayerState.ENDED) {
    trailer_video.playVideo()
  }
}



const trailer_video_cont = document.createElement('div')
trailer_video_cont.className = 'trailer_video_cont'
film_root_el.appendChild(trailer_video_cont)

const trailer_video_text_cont = document.createElement('div')
trailer_video_text_cont.className = 'trailer_video_text_cont'
film_root_el.appendChild(trailer_video_text_cont)

const film_fullscreen_button = document.createElement('div')
film_fullscreen_button.className = 'film_fullscreen_button'
film_fullscreen_button.addEventListener('click', render_film)
trailer_video_text_cont.appendChild(film_fullscreen_button)

const trailer_video_desc_el = document.createElement('div')
trailer_video_desc_el.className = 'trailer_video_desc'
trailer_video_text_cont.appendChild(trailer_video_desc_el)

const trailer_right_arrow_el = document.createElement('div')
trailer_right_arrow_el.className = 'right_arrow'
trailer_right_arrow_el.style.backgroundImage = 'url('+page_data.right_svg+')'
trailer_right_arrow_el.addEventListener('click', handle_trailer_right_arrow_el_click)
trailer_video_text_cont.appendChild(trailer_right_arrow_el)

const trailer_left_arrow_el = document.createElement('div')
trailer_left_arrow_el.className = 'left_arrow'
trailer_left_arrow_el.style.backgroundImage = 'url('+page_data.left_svg+')'
trailer_left_arrow_el.addEventListener('click', handle_trailer_left_arrow_el_click)
trailer_video_text_cont.appendChild(trailer_left_arrow_el)


function render_trailer () {
  trailer_video_cont.innerHTML = ''
  trailer_video = null

  trailer_video = document.createElement('div')
  trailer_video.className = 'trailer_video'
  trailer_video_cont.appendChild(trailer_video)
  trailer_video = new YT.Player(trailer_video, {
    height: page_data.films[current_film_index].trailer_height,
    width: page_data.films[current_film_index].trailer_width,
    videoId: page_data.films[current_film_index].trailer_youtube_id,
    playerVars: {
      'autoplay': 1,
      'controls': 0,
      'modestbranding': 1,
      'loop': 1,
      'playsinline': 1,
      'mute': 1,
      'rel': 0,
      'cc_load_policy': 0,
      'iv_load_policy': 3,
    },
    events: {
      'onReady': handle_trailer_yt_ready,
      'onStateChange': handle_trailer_yt_state_change,
      'onApiChange': handle_trailer_yt_api_change
    }
  })
  

  if (current_film_index == page_data.films.length - 1) {
    trailer_right_arrow_el.style.opacity = '0'
    trailer_right_arrow_el.style.pointerEvents = 'none'
  }

  if (current_film_index == 0) {
    trailer_left_arrow_el.style.opacity = '0'
    trailer_left_arrow_el.style.pointerEvents = 'none'
  }
}




//
// Film
//

let current_film_index = (parseInt((new URL(window.location)).searchParams.get('film')) - 1) || 0
let previous_film_index = null

let film_video = null
let film_yt_player = null


function destroy_film_video () {
  if (film_yt_player) {
    film_yt_player.destroy()  // also removes the iframe from the dom
    film_yt_player = null
    film_video = null
    return
  }
  if (film_video) {
    film_video.parentNode.removeChild(film_video)
    film_video = null
  }
}


function handle_film_yt_ready (event) {
  disable_captions(event.target)
  event.target.playVideo()
}


function handle_film_yt_api_change (event) {
  disable_captions(event.target)
}


function film_close_button_onclick () {
  film_video_cont.style.opacity = 0
  film_video_cont.style.pointerEvents = 'none'
  destroy_film_video()
}


const film_video_cont = document.createElement('div')
film_video_cont.className = 'film_video_cont'
film_root_el.appendChild(film_video_cont)

const film_close_button = document.createElement('div')
film_close_button.className = 'film_close_button'
film_close_button.innerHTML = 'back to <b>films</b>'
film_close_button.addEventListener('click', film_close_button_onclick)
film_video_cont.appendChild(film_close_button)


function render_film () {
  destroy_film_video()

  if (page_data.films[current_film_index].video_url) {
    film_video = document.createElement('video')
    film_video_cont.appendChild(film_video)
    film_video.src = page_data.films[current_film_index].video_url
    film_video.className = 'film_video'
  }
  else if (page_data.films[current_film_index].video_external_url) {
    window.open(page_data.films[current_film_index].video_external_url, '_self')
    return
  }
  else if (page_data.films[current_film_index].video_youtube_id) {
    const film_video_el = document.createElement('div')
    film_video_el.className = 'film_video'
    film_video_cont.appendChild(film_video_el)

    film_yt_player = new YT.Player(film_video_el, {
      videoId: page_data.films[current_film_index].video_youtube_id,
      playerVars: {
        'autoplay': 1,
        'playsinline': 1,
        'rel': 0,
        'modestbranding': 1,
        'cc_load_policy': 0,
        'iv_load_policy': 3,
      },
      events: {
        'onReady': handle_film_yt_ready,
        'onApiChange': handle_film_yt_api_change
      }
    })

    film_video = film_yt_player.getIframe()
    film_video.className = 'film_video'
    film_video.setAttribute('allowfullscreen', true)
    film_video.setAttribute('frameborder', 0)
    film_video.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture')
  }
  else {
    console.log(page_data.films[current_film_index])
  }


  film_video_cont.style.opacity = 1
  film_video_cont.style.pointerEvents = 'all'
  if (page_data.films[current_film_index].video_url) {
    film_video.play()
  }
}



//
// Gallery
//

const gallery_slides = []

let current_gallery_index = null
let previous_gallery_index = null

function gallery_close_button_onclick () {
  image_gallery_el.style.opacity = 0
  image_gallery_el.style.pointerEvents = 'none'
}

function handle_gallery_right_arrow_el_click () {
  previous_gallery_index = current_gallery_index
  current_gallery_index = current_gallery_index + 1

  if (previous_gallery_index == 0) {
    gallery_left_arrow_el.style.opacity = ''
    gallery_left_arrow_el.style.pointerEvents = ''
  }

  render_gallery()
}

function handle_gallery_left_arrow_el_click () {
  previous_gallery_index = current_gallery_index
  current_gallery_index = current_gallery_index - 1

  if (previous_gallery_index == page_data.films[current_film_index].album.length - 1) {
    gallery_right_arrow_el.style.opacity = ''
    gallery_right_arrow_el.style.pointerEvents = ''
  }

  render_gallery()
}


const image_gallery_el = document.createElement('div')
image_gallery_el.className = 'image_gallery'
film_root_el.appendChild(image_gallery_el)

const gallery_images_el = document.createElement('div')
gallery_images_el.className = 'gallery_images'
image_gallery_el.appendChild(gallery_images_el)

const gallery_close_button = document.createElement('div')
gallery_close_button.className = 'gallery_close_button'
gallery_close_button.innerHTML = 'back to <b>films</b>'
gallery_close_button.addEventListener('click', gallery_close_button_onclick)
image_gallery_el.appendChild(gallery_close_button)

const gallery_right_arrow_el = document.createElement('div')
gallery_right_arrow_el.className = 'right_arrow'
gallery_right_arrow_el.style.backgroundImage = 'url('+page_data.right_svg+')'
gallery_right_arrow_el.addEventListener('click', handle_gallery_right_arrow_el_click)
gallery_images_el.appendChild(gallery_right_arrow_el)

const gallery_left_arrow_el = document.createElement('div')
gallery_left_arrow_el.className = 'left_arrow'
gallery_left_arrow_el.style.backgroundImage = 'url('+page_data.left_svg+')'
gallery_left_arrow_el.addEventListener('click', handle_gallery_left_arrow_el_click)
gallery_images_el.appendChild(gallery_left_arrow_el)


function render_gallery () {
  if (previous_gallery_index) {
    gallery_slides[previous_gallery_index].style.opacity = '0'
  }
  gallery_slides[current_gallery_index].style.opacity = '1'

  if (current_gallery_index == page_data.films[current_film_index].album.length - 1) {
    gallery_right_arrow_el.style.opacity = '0'
    gallery_right_arrow_el.style.pointerEvents = 'none'
  }
  else {
    gallery_right_arrow_el.style.opacity = ''
    gallery_right_arrow_el.style.pointerEvents = ''
  }

  if (current_gallery_index == 0) {
    gallery_left_arrow_el.style.opacity = '0'
    gallery_left_arrow_el.style.pointerEvents = 'none'
  }
  else {
    gallery_left_arrow_el.style.opacity = ''
    gallery_left_arrow_el.style.pointerEvents = ''
  }
}



//
// Thumbs
//

function handle_film_thumbnail_click () {
  for (let i=0; i<gallery_slides.length; i++) {
    gallery_slides[i].parentNode.removeChild(gallery_slides[i])
  }
  gallery_slides.splice(0, gallery_slides.length)

  for (let i=0; i<page_data.films[current_film_index].album.length; i++) {
    const gallery_image_el = document.createElement('div')
    gallery_image_el.className = 'gallery_image'
    gallery_images_el.appendChild(gallery_image_el)
    gallery_image_el.style.backgroundImage = 'url('+page_data.films[current_film_index].album[i].url+')'
    gallery_slides.push(gallery_image_el)

    if (page_data.films[current_film_index].album[i].desc != '') {
      const gallery_image_desc_el = document.createElement('div')
      gallery_image_desc_el.className = 'gallery_image_desc'
      gallery_image_desc_el.innerHTML = page_data.films[current_film_index].album[i].desc
      gallery_image_el.appendChild(gallery_image_desc_el)
    }

    if (i == current_gallery_index) {
      gallery_image_el.style.opacity = '1'
    }
  }
  image_gallery_el.style.opacity = '1'
  image_gallery_el.style.pointerEvents = 'all'

  render_gallery()
}


const film_thumbnails_el = document.createElement('div')
film_thumbnails_el.className = 'film_thumbnails'
film_root_el.appendChild(film_thumbnails_el)


function render_thumbs () {
  film_thumbnails_el.innerHTML = ''
  for (let i=0; i<page_data.films[current_film_index].album.length; i++) {
    const film_thumbnail_cont = document.createElement('div')
    film_thumbnail_cont.className = 'film_thumbnail_cont'
    film_thumbnails_el.appendChild(film_thumbnail_cont)

    const film_thumbnail_el = document.createElement('div')
    film_thumbnail_el.className = 'film_thumbnail'
    film_thumbnail_cont.appendChild(film_thumbnail_el)
    film_thumbnail_el.style.backgroundImage = 'url('+page_data.films[current_film_index].album[i].url+')'

    film_thumbnail_el.addEventListener('click', function () {
      current_gallery_index = i

      handle_film_thumbnail_click()
    })
  }
}



//
// Featured products
//

const featured_products = document.createElement('div')
featured_products.className = 'featured_products'
film_root_el.appendChild(featured_products)

function render_featured_products () {
  featured_products.innerHTML = ''
  
  const featured_products_label = document.createElement('div')
  featured_products_label.className = 'featured_products_label'
  featured_products_label.innerHTML = 'Featured products'
  featured_products.appendChild(featured_products_label)


  for (let i=0; i<page_data.films[current_film_index].featured_products.length; i++) {
    const p = page_data.films[current_film_index].featured_products[i]

    const featured_product_el = document.createElement('a')
    featured_product_el.className = 'featured_product'
    featured_product_el.href = p.link
    featured_products.appendChild(featured_product_el)

    const featured_product_image_el = document.createElement('img')
    featured_product_image_el.className = 'featured_product_image'
    featured_product_image_el.src = p.image_url
    featured_product_el.appendChild(featured_product_image_el)

    const featured_product_title_el = document.createElement('div')
    featured_product_title_el.className = 'featured_product_title'
    featured_product_title_el.innerHTML = p.title
    featured_product_el.appendChild(featured_product_title_el)
  }
}


//
// Main
//

function handle_window_popstate () {
  current_film_index = (parseInt((new URL(window.location)).searchParams.get('film')) - 1) || 0
  previous_film_index = null

  render_main()
}

window.addEventListener('popstate', handle_window_popstate)


function render_main () {
  render_trailer()
  render_thumbs()
  render_featured_products()
  film_fullscreen_button.innerHTML = (page_data.films[current_film_index].film_button ? '<b>'+page_data.films[current_film_index].film_button+'</b> ' : '<b>watch film</b> ')+(current_film_index+1)+' of '+page_data.films.length
  trailer_video_desc_el.innerHTML = page_data.films[current_film_index].film_desc
}


window.YT.ready(function handle_yt_ready () {
  render_main()
});

